import MainBlock from './components/main-block';
import GiveAGift from './components/give-a-gift';
import AboutBlock from './components/about-block';
import Blog from './components/blog';
import Footer from './components/footer';
import Contacts from './components/contacts';

function App() {
  return (
    <>
      <MainBlock />
      <GiveAGift />
      <AboutBlock />
      <Blog />
      <Contacts />
      <Footer />
    </>
  );
}

export default App;
